import React, { useEffect, useState } from "react";
import { FaRegUser } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeamMmebers } from "../../../api/api";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";

export default function Step4Notifications({ formData, setFormData }) {
  const dispatch = useDispatch();
  const [showAddUser, setShowAddUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Data, setData] = useState([]);
  const { data } = useSelector((state) => state?.authUser);
  const org_id = data?.data?.organization_id;

  const fetchMembers = async () => {
    try {
      setLoading(true);
      const res = await fetchTeamMmebers(org_id);
      setData(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching members", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  const toggleUser = (userId) => {
    setFormData((prev) => {
      const currentList = prev.notification_data || [];
      const exists = currentList.find((n) => n.userId === userId);
      if (exists) {
        return {
          ...prev,
          notification_data: currentList.filter((n) => n.userId !== userId),
        };
      } else {
        return {
          ...prev,
          notification_data: [...currentList, { userId, alerts: [] }],
        };
      }
    });
  };

  const toggleAlert = (userId, alertType) => {
    setFormData((prev) => {
      const currentList = prev.notification_data || [];
      return {
        ...prev,
        notification_data: currentList.map((n) => {
          if (n.userId === userId) {
            const hasAlert = n.alerts.includes(alertType);
            return {
              ...n,
              alerts: hasAlert
                ? n.alerts.filter((a) => a !== alertType)
                : [...n.alerts, alertType],
            };
          }
          return n;
        }),
      };
    });
  };

  const isUserSelected = (userId) =>
    (formData.notification_data || []).some((n) => n.userId === userId);

  const hasAlert = (userId, alertType) =>
    (formData.notification_data || []).some(
      (n) => n.userId === userId && n.alerts.includes(alertType)
    );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "InviteUser",
        showModal: true,
      })
    );
  };

  return (
    <>
      <h4>Notifications and Alerts</h4>
      <p className="formTitle mt-3 mb-4">
        Get notified instantly - customize your alert settings here.
      </p>

      <div className="mt-4 cstTableCls">
        <table className="table rounded-3 border">
          <thead>
            <tr>
              <th width="35%">Users</th>
              <th width="35%">Alerts</th>
              <th className="text-end">
                <button
                  onClick={handleAddClick}
                  className="btn transParent2"
                  style={{ borderColor: "#5C45FE" }}
                >
                  + Add User
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            {Data.map((user) => (
              <tr key={user._id}>
                <td>
                  <input
                    type="checkbox"
                    className="me-2"
                    checked={isUserSelected(user._id)}
                    onChange={() => toggleUser(user._id)}
                  />
                  {user.user_name || "Unnamed"}
                </td>
                <td colspan="2">
                  <input
                    type="checkbox"
                    className="me-2"
                    disabled={!isUserSelected(user._id)}
                    checked={hasAlert(user._id, "Email")}
                    onChange={() => toggleAlert(user._id, "Email")}
                  />{" "}
                  Email
                  <input
                    type="checkbox"
                    className="ms-4 me-2"
                    disabled={!isUserSelected(user._id)}
                    checked={hasAlert(user._id, "SMS")}
                    onChange={() => toggleAlert(user._id, "SMS")}
                  />{" "}
                  SMS
                  <input
                    type="checkbox"
                    className="ms-4 me-2"
                    disabled={!isUserSelected(user._id)}
                    checked={hasAlert(user._id, "Call")}
                    onChange={() => toggleAlert(user._id, "Call")}
                  />{" "}
                  Call
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAddUser && (
        <div className="rightModal addUser">
          <h3 className="titleModal p-3 border-bottom d-flex gap-2 align-items-center">
            <FaRegUser size={20} /> Add User
            <button
              onClick={() => setShowAddUser(false)}
              className="closeBtn ms-auto"
            >
              <IoClose size={24} />
            </button>
          </h3>
          <div className="px-4 py-3">
            <input className="form-control mb-3" placeholder="User Name" />
            <input className="form-control mb-3" placeholder="Email ID" />
            <input className="form-control mb-3" placeholder="Contact No." />
          </div>
        </div>
      )}
    </>
  );
}
